import CompanyScansTable from './companyScansTable.container';

export default CompanyScansTable;
